import React from 'react'
import {Box, BoxProps, useMultiStyleConfig} from '@chakra-ui/react'

interface ColorCircleProps {
    hexCodes: string | null
    /**
     * When true the swatch shows the outer selection ring (Figma "Selected"/"Hover" state).
     * When false only the inner colour dot (with its dark stroke) is shown, no outer ring.
     */
    selected?: boolean
}

/**
 * Renders a colour swatch following the Figma "Color dots" (VARIANTE NUOVA) design:
 * - an inner dot filled with the hex colour, always carrying a dark (#262626) stroke;
 * - an outer ring (with a small gap) in light grey (#d2d2d2) that appears only when `selected`.
 *
 * Hex parsing:
 * - 1 hex  → solid fill
 * - 2+ hex → left/right split (two halves)
 */
const ColorCircle: React.FC<ColorCircleProps> = ({hexCodes, selected = false}) => {
    const styles = useMultiStyleConfig('ColorCirle', {selected}) as Record<string, BoxProps>
    const [first, second] = hexCodes?.split(',').map((s) => s.trim()) ?? []

    return (
        <Box className="cc-color-circle__ring" {...styles.outerRing}>
            {!second ? (
                <Box {...styles.cirle} bg={first} />
            ) : (
                <Box {...styles.cirle}>
                    <Box position="absolute" top={0} left={0} w="50%" h="100%" bg={first} />
                    <Box position="absolute" top={0} right={0} w="50%" h="100%" bg={second} />
                </Box>
            )}
        </Box>
    )
}

export {ColorCircle}
